import { Box, Typography } from "@mui/material";
import TooltipPopover from "../../../../../components/shared/others/TooltipPopover";

const TooltipFineAndInterest = () => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <TooltipPopover>
                <Typography variant="body1">
                    Use este campo apenas se quiser registrar que a parcela foi paga com uma quantia (em R$) superior ao valor cobrado inicialmente.
                </Typography>
            </TooltipPopover>
        </Box>
    )
}

export default TooltipFineAndInterest;